import 'intersection-observer'

const threshold = []

for (let i = 0.0; i < 1.01; i += 0.01) {
  threshold.push(parseFloat(i.toFixed(2)))
}

class SectionIntersection {
  constructor () {
    this.listeners = new Map()
    this.targets = new Map()

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), { threshold })
  }

  onIntersect (entries) {
    entries.map(entry => {
      this.targets.set(entry.target, entry.intersectionRatio)
    })

    let focused = this.targets.toJSON().reduce((acc, current) => {
      return acc[1] > current[1] ? acc : current
    })

    if (focused && this.listeners.has(focused[0])) {
      const cb = this.listeners.get(focused[0])

      cb()
    }
  }

  on (el, cb) {
    this.listeners.set(el, cb)
  }

  observe (element) {
    this.targets.set(element, 0)
    this.observer.observe(element)
  }

  unobserve (element) {
    this.listeners.delete(element)
    this.targets.delete(element)
    this.observer.unobserve(element)
  }
}

const sectionIntersection = new SectionIntersection()

export default sectionIntersection



// WEBPACK FOOTER //
// ./src/library/section-intersection.js